import React, { useEffect, useState } from "react";
import {
  connectWallet,
  getCurrentWalletConnected,
  mintLand,
} from "../../utils/interact.js";

import { NavLink } from "react-router-dom";
import $ from "jquery";
//import "jquery-syotimer";

import jQueryBridget from "jquery-bridget";
import jQuery from "jquery";

// import './script.js'
import "./navbar.css";
import { NavbarLogo } from "../../utils/allImgs";
import { Addshrink } from "../../utils";
import Preloader from "../../components/Preloader";
import data from "../../data/data-layouts/data-Head.json";

function Head({ Title }) {
  //State variables
  const [walletAddress, setWallet] = useState("");
  const [status, setStatus] = useState("");
  const [buttonInfo, setButton] = useState("");

  useEffect(async () => {
    //TODO: implement
    const { address, status } = await getCurrentWalletConnected();
    setWallet(address);
    setStatus(status);
    if (status == " Connected ") {
      setButton(status);
    }
    if (status == "Metamask Required") {
      setButton(
        <a
          target="_blank"
          href={`https://metamask.io/download.html`}
          style={{ color: "white" }}
        >
          MetaMask Required
        </a>
      );
    }
    if (status == "Wallet Required") {
      setButton(status);
    }
    if (status == "Error Connecting") {
      setButton(status);
    }
    //else {setButton("Connect Wallet");}
    addWalletListener();
  }, []);

  const connectWalletPressed = async () => {
    //TODO: implement
    const walletResponse = await connectWallet();
    setStatus(walletResponse.status);
    setWallet(walletResponse.address);
    if (walletResponse.status == " Connected ") {
      setButton(" Connected ");
    } else {
      setButton("Connect Wallet");
    }
    addWalletListener();
  };

  function addWalletListener() {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", (accounts) => {
        if (accounts.length > 0) {
          setWallet(accounts[0]);
          setStatus(" Connected ");
          setButton("Connected");
        } else {
          setWallet("");
          setStatus("Please Connect to MetaMask");
          setButton("Connect Wallet");
        }
      });
    } else {
      setStatus(
        <a target="_blank" href={`https://metamask.io/download.html`}>
          You must install Metamask, a virtual Ethereum wallet, in your browser.
        </a>
      );
    }
  }

  useEffect(() => {
    Addshrink();
  }, [window.pageYOffset]);

  useEffect(() => {
    // jQueryBridget( 'jquery-syotimer', 'jquery' , $ );
    // if ($('.simple_timer').length) {
    //     $('.simple_timer').syotimer({
    //         year: 2025,
    //         month: 3,
    //         day: 9,
    //         hour: 20,
    //         minute: 30
    //     })
    // }
    /*    $('.simple_timer').syotimer({
                year: 2025,
                month: 3,
                day: 9,
                hour: 20,
                minute: 30
            }) */
  }, []);

  return (
    <>
      <Preloader Title={Title} />
      <nav
        className="navbar navbar-expand-lg navbar-white fixed-top"
        id="banner"
      >
        <div className="container">
          <NavLink className="navbar-brand" to="/">
            <span>
              <img src={NavbarLogo} alt="logo" />
            </span>
          </NavLink>

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#collapsibleNavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="collapsibleNavbar">
            <ul className="navbar-nav ml-auto">
              {/* <li className="nav-item">
                            <NavLink className="nav-link" to="/">Home</NavLink>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link" href="#landOptions">Discover</a>
                            <div className="dropdown-menu"> */}
              {/*
                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle" to="#" data-toggle="dropdown">Discover</NavLink>
                            <div className="dropdown-menu">*/}

              {/*data[0].dataUp && data[0].dataUp.map((item , i) => (
                                    <NavLink key={i} className="dropdown-item" to={item.path}>{item.title}</NavLink>
                                ))*/}
              {/* </div>
                        </li> */}
              {/*
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/activity">Activity</NavLink>
                        </li>*/}
              {/*
                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle" to="#"  data-toggle="dropdown">Pages</NavLink>
                            <div className="dropdown-menu">
                                {data[1].dataDown && data[1].dataDown.map((item , i) => (
                                    <NavLink key={i} className="dropdown-item" to={item.path}>{item.title}</NavLink>
                                ))}
                            </div>
                        </li> */}
              {/* <li className="nav-item">
                            <a className="nav-link" href="#contactInfo">Contact</a>
                        </li> */}
              <li className="lh-55px">
                <li onClick={connectWallet} className="btn login-btn ml-50">
                  {buttonInfo}
                </li>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Head;
